<groundworks-modal>
  <groundworks-modal-header [title]="'Change Order'" [isCancellable]="true" (cancelModal)="cancel()" />
  <groundworks-modal-body>
    <groundworks-term-value [items]="summaryItems()" [compact]="true" />
    <groundworks-card [title]="'Upsell'" [isCollapsible]="true" [cardClasses]="['mb-3', 'mt-4', 'shadow-none']" [collapsibleVariant]="'box'" [initialCollapsed]="true" [disabled]="hasDescopeChanges() || hasTaxChanges()">
      <groundworks-card-body>
        <div class="mt-3">
          <div class="mb-2">
            <label for="salespersonSelect" class="form-label">Salesperson</label>
            @if (showAllCompany()) {
              <!-- All-company directory: flat (no groupBy), virtualised + typeahead-gated for the
                   ~10k-row list. ng-select's groupBy input is not nullable under strict templates,
                   so the two list shapes use separate elements rather than a nullable binding. -->
              <ng-select
                inputId="salespersonSelect"
                [items]="displayedSalespeople()"
                bindLabel="label"
                bindValue="id"
                [virtualScroll]="true"
                [minTermLength]="2"
                placeholder="Select a Salesperson to Credit"
                [ngModel]="selectedSalesperson()?.id"
                (ngModelChange)="onSalespersonChange($event)">
              </ng-select>
            } @else {
              <ng-select
                inputId="salespersonSelect"
                [items]="displayedSalespeople()"
                bindLabel="label"
                bindValue="id"
                [groupBy]="creditGroupLabel"
                placeholder="Select a Salesperson to Credit"
                [ngModel]="selectedSalesperson()?.id"
                (ngModelChange)="onSalespersonChange($event)">
              </ng-select>
              <button
                type="button"
                class="btn btn-link btn-sm p-0 mt-1"
                data-testid="load-all-company"
                (click)="loadAllCompany()">
                Load all company employees
              </button>
            }
          </div>

          <div class="mb-2">
            <label for="productSelect" class="form-label">Product</label>
            <div class="d-flex gap-2">
              <div class="flex-grow-1">
                <ng-select
                  inputId="productSelect"
                  [items]="products()"
                  bindLabel="name"
                  placeholder="Select a Product"
                  [ngModel]="selectedProduct()"
                  (ngModelChange)="selectedProduct.set($event)">
                </ng-select>
              </div>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                [disabled]="!selectedProduct()"
                (click)="addUpsellProduct()">
                Add Product
              </button>
            </div>
          </div>

          @if (upsellProducts().length > 0) {
            <div class="mt-3" id="productTable">
              <groundworks-table [data]="upsellTableData()" />
            </div>
          }
        </div>
      </groundworks-card-body>
    </groundworks-card>

    <groundworks-card [title]="'Descope'" [isCollapsible]="true" [cardClasses]="['mb-3', 'shadow-none']" [collapsibleVariant]="'box'" [initialCollapsed]="true" [disabled]="hasUpsellProducts() || hasTaxChanges()">
      <groundworks-card-body>
        <div class="mt-3">
          <groundworks-table [data]="descopeTableData()" />
        </div>
      </groundworks-card-body>
    </groundworks-card>

    @if (taxes().length > 0) {
      <groundworks-card [title]="'Taxes'" [isCollapsible]="true" [cardClasses]="['mb-3', 'shadow-none']" [collapsibleVariant]="'box'" [initialCollapsed]="true" [disabled]="hasUpsellProducts() || hasDescopeChanges()">
        <groundworks-card-body>
          <div class="mt-3" id="taxTable">
            <groundworks-table [data]="taxesTableData()" />
          </div>
        </groundworks-card-body>
      </groundworks-card>
    }

    @if (descopeMoneyOnlyWarning()) {
      <div class="alert alert-warning mb-0 mt-3" role="alert">{{ descopeMoneyOnlyWarning() }}</div>
    }

    @if (errorMessage()) {
      <div class="alert alert-danger mb-0 mt-3" role="alert">{{ errorMessage() }}</div>
    }
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
